// actions.js
import {
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAILURE,
  DELETE_DEPARTMENTS_REQUEST,
  DELETE_DEPARTMENTS_FAILURE,
  DELETE_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENT_REQUEST,
  FETCH_DEPARTMENT_SUCCESS,
  FETCH_DEPARTMENT_FAILURE,
  UPDATE_DEPARTMENTS_REQUEST,
  UPDATE_DEPARTMENTS_SUCCESS,
  UPDATE_DEPARTMENTS_FAILURE,
  FETCH_DEPARTMENTS_RELEASE_REQUEST,
  FETCH_DEPARTMENTS_RELEASE_SUCCESS,
  FETCH_DEPARTMENTS_RELEASE_FAILURE,
  OPEN_EDIT_PAGE_DEPARTMENT,
  OPEN_EDIT_PAGE_DEPARTMENT_SUCCESS,
  CLEAR_DEPARTMENT_ERRORS,
  CLEAR_DEPARTMENT_SUCCESS,
} from './actionTypes';

export const fetchDepartmentsRequest = () => ({
  type: FETCH_DEPARTMENTS_REQUEST,
});

export const fetchDepartmentsSuccess = (departments) => ({
  type: FETCH_DEPARTMENTS_SUCCESS,
  payload: departments,
});

export const fetchDepartmentsFailure = (error) => ({
  type: FETCH_DEPARTMENTS_FAILURE,
  payload: error,
});

export const fetchDepartmentsReleaseRequest = () => ({
  type: FETCH_DEPARTMENTS_RELEASE_REQUEST,
});

export const fetchDepartmentsReleaseSuccess = (departmentsRelease) => ({
  type: FETCH_DEPARTMENTS_RELEASE_SUCCESS,
  payload: departmentsRelease,
});

export const fetchDepartmentsReleaseFailure = (error) => ({
  type: FETCH_DEPARTMENTS_RELEASE_FAILURE,
  payload: error,
});

export const fetchDepartmentRequest = (id) => ({
  type: FETCH_DEPARTMENT_REQUEST,
  payload: id
});

export const fetchDepartmentSuccess = (department) => ({
  type: FETCH_DEPARTMENT_SUCCESS,
  payload: department,
});

export const fetchDepartmentFailure = (error) => ({
  type: FETCH_DEPARTMENT_FAILURE,
  payload: error,
});

export const openEditPageDepartment = (id, navigate) => ({
  type: OPEN_EDIT_PAGE_DEPARTMENT,
  payload: { id, navigate }
});

export const openEditPageDepartmentSuccess = () => ({
  type: OPEN_EDIT_PAGE_DEPARTMENT_SUCCESS,
});


export const updateDepartmentRequest = (department, navigate) => ({
  type: UPDATE_DEPARTMENTS_REQUEST,
  payload: { department, navigate }
});

export const updateDepartmentSuccess = () => ({
  type: UPDATE_DEPARTMENTS_SUCCESS,
});

export const updateDepartmentFailure = (error) => ({
  type: UPDATE_DEPARTMENTS_FAILURE,
  payload: error,
});

export const deleteDepartmentRequest = (id) => ({
  type: DELETE_DEPARTMENTS_REQUEST,
  payload: id
});

export const deleteDepartmentSuccess = (id) => ({
  type: DELETE_DEPARTMENTS_SUCCESS,
  payload: id,
});

export const deleteDepartmentFailure = (error) => ({
  type: DELETE_DEPARTMENTS_FAILURE,
  payload: error,
});

export const clearDepartmentErrors = () => ({
  type: CLEAR_DEPARTMENT_ERRORS,
});

export const clearDepartmentSuccess = () => ({
  type: CLEAR_DEPARTMENT_SUCCESS,
});